import PageFacilityVisitsReport from "./PageFacilityVisitsReport.vue";
import PageManagementSummary from "./PageManagementSummary.vue";
import PagePenetrationsAndAnnualizedLifetimeRevenueReport from "./PagePenetrationsAndAnnualizedLifetimeRevenueReport.vue";
import PageRevenueReport from "./PageRevenueReport.vue";
import PageMonthlyTrends from "./PageMonthlyTrends.vue";
import PageMoveInSourcesReport from "./PageMoveInSourcesReport.vue";

const routes = {
  navigation: [
    {
      path: "/management_summary",
      name: "ManagementSummary",
      component: PageManagementSummary,
    },
    {
      path: "/management_summary/facility_visits_report",
      name: "FacilityVisitsReport",
      component: PageFacilityVisitsReport,
    },
    {
      path: "/management_summary/penetrations_and_annualized_revenue_report",
      name: "PenetrationsAndAnnualizedLifetimeRevenueReport",
      component: PagePenetrationsAndAnnualizedLifetimeRevenueReport,
    },
    {
      path: "/management_summary/revenue_report",
      name: "RevenueReport",
      component: PageRevenueReport,
    },
    {
      path: "/management_summary/monthly_trends",
      name: "MonthlyTrends",
      component: PageMonthlyTrends,
    },
    {
      path: "/management_summary/move_in_sources_report",
      name: "MoveInSourcesReport",
      component: PageMoveInSourcesReport,
    },
  ],
};
export default routes;
